import { render, staticRenderFns } from "./DashboardCashier.vue?vue&type=template&id=0170a6ba&scoped=true&"
import script from "./DashboardCashier.vue?vue&type=script&lang=js&"
export * from "./DashboardCashier.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCashier.vue?vue&type=style&index=0&id=0170a6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170a6ba",
  null
  
)

export default component.exports